/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/visitor',
    component: Layout,
    name: 'Visitor',
    menuid: 66,
    systemtypeid: 4,
    meta: {
      title: 'VisitorTitle',
      icon: 'peoples'
    },
    children: [
      {
        path: 'create',
        component: () => import('@/views/visitor/key/create'),
        name: 'VisitorCreate',
        menuid: 83,
        systemtypeid: 4,
        meta: {title: 'VisitorCreate', icon: 'form'}
      }, 
      {
        path: 'key/index',
        component: () => import('@/views/visitor/key/list'),
        name: 'VisitorKeyList',
        menuid: 84,
        systemtypeid: 4,
        meta: {title: 'VisitorKeyList', icon: 'people'}
      },   
      {
        path: 'apply/index',
        component: () => import('@/views/visitor/apply/list'),
        name: 'VisitorApply',
        menuid: 144,
        systemtypeid: 4,
        meta: {title: 'VisitorApply', icon: 'edit'}
      },  
      {
        path: 'apply/bodypic',
        component: () => import('@/views/visitor/apply/bodypic'),
        name: 'VisitorBodyPicApply',
        menuid: 165,
        systemtypeid: 4,
        meta: {title: 'VisitorBodyPicApply', icon: 'edit'}
      }, 
      {
        path: 'black/index',
        component: () => import('@/views/base/user/black/list'),
        name: 'UserBlackList',
        menuid: 147,
        systemtypeid: 4,
        meta: {title: 'UserBlackList', icon: 'user'}
      }, 
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/visitor.js